import * as React from 'react';
import './loading.css';

export const Loading = () => (
  <div className="loading-shading">
    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
);
